// /*颜色渐变*/
var jsgradient = {
  inputA: '',
  inputB: '',
  inputC: '',
  gradientElement: '',

  // Convert a hex color to an RGB array e.g. [r,g,b]
  // Accepts the following formats: FFF, FFFFFF, #FFF, #FFFFFF
  hexToRgb: function (hex) {
    var r, g, b, parts
    // Remove the hash if given
    hex = hex.replace('#', '')
    // If invalid code given return white
    if (hex.length !== 3 && hex.length !== 6) {
      return [255, 255, 255]
    }
    // Double up charaters if only three suplied
    if (hex.length == 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
    }
    // Convert to [r,g,b] array
    r = parseInt(hex.substr(0, 2), 16)
    g = parseInt(hex.substr(2, 2), 16)
    b = parseInt(hex.substr(4, 2), 16)

    return [r, g, b]
  },

  // Converts an RGB color array e.g. [255,255,255] into a hexidecimal color value e.g. 'FFFFFF'
  rgbToHex: function (color) {
    // Set boundries of upper 255 and lower 0
    color[0] = (color[0] > 255) ? 255 : (color[0] < 0) ? 0 : color[0]
    color[1] = (color[1] > 255) ? 255 : (color[1] < 0) ? 0 : color[1]
    color[2] = (color[2] > 255) ? 255 : (color[2] < 0) ? 0 : color[2]

    return this.zeroFill(color[0].toString(16), 2) + this.zeroFill(color[1].toString(16), 2) + this.zeroFill(color[2].toString(16), 2)
  },

  // Pads a number with specified number of leading zeroes
  zeroFill: function (number, width) {
    width -= number.toString().length
    if (width > 0) {
      return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
    }
    return number
  },

  // Generates an array of color values in sequence from 'colorA' to 'colorB' using the specified number of steps
  generateGradient: function (colorA, colorB, steps) {
    var result = [];
      var rInterval; var gInterval; var bInterval

    colorA = this.hexToRgb(colorA) // [r,g,b]
    colorB = this.hexToRgb(colorB) // [r,g,b]
    steps -= 1 // Reduce the steps by one because we're including the first item manually

    // Calculate the intervals for each color
    rStep = (Math.max(colorA[0], colorB[0]) - Math.min(colorA[0], colorB[0])) / steps
    gStep = (Math.max(colorA[1], colorB[1]) - Math.min(colorA[1], colorB[1])) / steps
    bStep = (Math.max(colorA[2], colorB[2]) - Math.min(colorA[2], colorB[2])) / steps

    result.push('#' + this.rgbToHex(colorA))

    // Set the starting value as the first color value
    var rVal = colorA[0]; var gVal = colorA[1]; var  bVal = colorA[2]

    // Loop over the steps-1 because we're includeing the last value manually to ensure it's accurate
    for (var i = 0; i < (steps - 1); i++) {
      // If the first value is lower than the last - increment up otherwise increment down
      rVal = (colorA[0] < colorB[0]) ? rVal + Math.round(rStep) : rVal - Math.round(rStep)
      gVal = (colorA[1] < colorB[1]) ? gVal + Math.round(gStep) : gVal - Math.round(gStep)
      bVal = (colorA[2] < colorB[2]) ? bVal + Math.round(bStep) : bVal - Math.round(bStep)
      result.push('#' + this.rgbToHex([rVal, gVal, bVal]))
    };

    result.push('#' + this.rgbToHex(colorB))

    return result
  },

  gradientList: function (colorA, colorB, list) {
    var list = (typeof list === 'object') ? list : document.querySelector(list)

    var listItems = list.querySelectorAll('li');
      var steps = listItems.length;
      var colors = jsgradient.generateGradient(colorA, colorB, steps)

    for (var i = 0; i < listItems.length; i++) {
      var item = listItems[i]
      item.style.backgroundColor = colors[i]
    };
  }
}

var DimensionValueInfo = {
  createNew: function () {
    var dimensionInfo = {}

    dimensionInfo.dimensionCode = '';
    dimensionInfo.name = '';
    dimensionInfo.isNewData = false
    dimensionInfo.id = '';
    dimensionInfo.Explanation = '';

    dimensionInfo.init = function (code, id, name, description, isnew, orderNumber) {
      dimensionInfo.dimensionCode = code
      dimensionInfo.name = name
      dimensionInfo.isNewData = isnew
      dimensionInfo.id = id
      dimensionInfo.Explanation = description
      dimensionInfo.OrderNumber = orderNumber
    };
    return dimensionInfo
  }
}

var FactValueInfo = {
  createNew: function () {
    var factValueInfo = {}
    factValueInfo.Id = '';
    factValueInfo.FactValue = NaN
    //判断是否是用户数据
    factValueInfo.IsUserData = function () {
      if (factValueInfo.Id.indexOf('userdata:true') == -1) return false
      return true
    };
    factValueInfo.isNewData = false
    return factValueInfo
  }
}

//数据索引
var FactValueIndex = {
  createNew: function () {
    var bll = {}

    bll.indexArray = new Array()
    bll.index_id_Array = new Array() //纬度索引
    bll.id_indexes = Array() //id数据索引

    bll.codeArray = new Array() //code
    bll.codeValuesArray = new Array() //纬度值
    bll.codeTextArray = new Array()

    //加载索引
    bll.init = function (data) {
      var i
      for (i = 0; i < data.length; i++) {
        bll.loadIndex(i, data[i].Id)
      }
    }

    //初始化纬度值索引
    bll.initCodeValues = function (code, codeValueArray) {
      codeValueArray.sort()
      var index = bll.getCodeIndex(code)
      if (bll.codeValuesArray[index] == null) {
        bll.codeValuesArray[index] = new Array()
      }
      bll.codeValuesArray[index] = codeValueArray

      // document.write("<BR/>" + code + ":" + index + "Value:" + bll.codeValuesArray[index]);
    };

    bll.initCodeValue = function (code, codeValue) {
      var index = bll.getCodeIndex(code)
      if (bll.codeValuesArray[index] == null) {
        bll.codeValuesArray[index] = new Array()
      }
      var k = bll.codeValuesArray[index].length
      bll.codeValuesArray[index][k] = codeValue

      // document.write("<BR/>" + code + ":" + index + "Value:" + bll.codeValuesArray[index]);
    };
    // 初始化Code对应的Name
    bll.initCodeText = function (code, codeText) {
      // alert(code + codeText);
      var index = bll.getCodeIndex(code)
      bll.codeTextArray[index] = codeText
    };
    bll.getCodeText = function (code) {
      var index = bll.getCodeIndex(code)

      return bll.codeTextArray[index]
    };
    // 获取纬度所在数组的索引
    bll.getCodeIndex = function (code) {
      code = code.toLowerCase()

      var index = bll.codeArray.indexOf(code)

      if (index == -1) {
        index = bll.codeArray.push(code)
        index = index - 1
        bll.codeValuesArray[index] = new Array()
      }

      return index

    };
    // 获取纬度所有值
    bll.getCodeValues = function (code) {
      var index = bll.getCodeIndex(code)
      return bll.codeValuesArray[index]
    };

    // 加载索引
    bll.loadIndex = function (rowIndex, id) {
      id = id.toLowerCase()
      bll.id_indexes[rowIndex] = id //id索引
      //加载纬度索引
      var s = id.split('_')
      var i
      for (i = 0; i < s.length; i++) {
        if (s[i] != null && s[i] != '' && s[i].indexOf(':') > -1) {
          var s1 = s[i].split(':')
          if (s1.length == 2 && s1[0] != '' && s1[1] != '') {
            bll.addIndex(s1[0], s1[1], rowIndex)

          }
        }
      }
    }

    bll.getKey = function (code, codevalue) {
      var key = '{' + code + '_' + codevalue + '}'
      return key.toLowerCase()
    };
    // 根据纬度信息获取FactValue的所在行 code="region" codeValue=2
    bll.getFactValueRowIndexes = function (code, codeValue) {
      var k = bll.getKey(code, codeValue)
      var index = bll.indexArray.indexOf(k)
      if (index == -1) return new Array()
      return bll.index_id_Array[index]
    };
    // 新增索引
    bll.addIndex = function (code, codevalue, rowIndex) {
      var key = bll.getKey(code, codevalue)
      var index = bll.indexArray.indexOf(key)
      if (index == -1) {
        index = bll.indexArray.push(key)
        index = index - 1

      }
      if (bll.index_id_Array[index] == null) bll.index_id_Array[index] = new Array()
      bll.index_id_Array[index].push(rowIndex)
    };

    // 输入Id，返回Id所在索引
    bll.getIndexById = function (id) {
      id = id.toLowerCase()
      return bll.id_indexes.indexOf(id)

    };
    bll.getCodes = function () {
      return bll.codeArray
    };
    // 获取2数组交集
    bll.getInArray = function (arr1, arr2) {
      if (arr1 == null || arr2 == null) return null
      // document.write("<BR/>arr1:" + arr1);
      // document.write("<BR/>arr2:" + arr2);

      var hash = {}
      var intersect = {}
      var res = []
      for (var i = 0, l = arr1.length; i < l; i++)
        {hash[arr1[i]] = true;}
      for (var i = 0, l = arr2.length; i < l; i++)
        {hash[arr2[i]] && (intersect[arr2[i]] = true);}
      for (var k in intersect)
        {res.push(k);}

      /// document.write("<BR/>res:" + res);
      return res
    };

    // 获取事实表数据 array:[["region","1"],["indicator","2"],["time","2001"]] isuer:true
    bll.getFactValueRowIndex = function (array, isuser) {
      var k = bll.getFactValueRowId(array)
      var i
      var index = -1
      if (isuser) {
        var temp = k + '_userdata:true_'
        index = bll.id_indexes.indexOf(temp)
        // if (index != -1) alert(index);
      }
      if (index == -1) {
        var temp = k + '_userdata:false_'
        index = bll.id_indexes.indexOf(temp)

      }
      // alert(k);
      // alert(bll.id_indexes[0]);
      return index
    };
    // 获取事实表数据 array:[["region","1"],["indicator","2"],["time","2001"]]
    bll.getFactValueRowId = function (array) {
      var k = ''
      var i
      //  alert(bll.codeArray);
      for (i = 0; i < bll.codeArray.length; i++) {
        var dcode = bll.codeArray[i]
        var j
        for (j = 0; j < array.length; j++) {
          if (dcode == array[j][0].toLowerCase()) {
            k += '_' + dcode + ':' + array[j][1]
            break;
          }
        }
      }
      return k
    };

    // 获取事实表数据 array:[["region","1"],["indicator","2"],["time","2001"]] isuer:true
    bll.getFactValueRowIndexByKeys = function (array) {
      if (array == null || array.length == 0) return null
      var t = bll.getFactValueRowIndexes(array[0][0], array[0][1])
      var i
      for (i = 1; i < array.length; i++) {
        var t1 = bll.getFactValueRowIndexes(array[i][0], array[i][1])
        t = bll.getInArray(t, t1)

      }

      return t

    };

    return bll
  }
}

//纬度集合
var DimenensionBLL = {
  createNew: function () {
    var dimension = {}
    dimension.data = new Array()
    dimension.dataIndexes = new Array()
    dimension.maxId = 0
    dimension.init = function (code, id, name, description, isnew, orderNumber) {
      var info = DimensionValueInfo.createNew()
      info.init(code, id, name, description, isnew, orderNumber)

      if (id > dimension.maxId) dimension.maxId = id

      var indexKey = dimension.getKey(code, id)
      var rowIndex = dimension.data.length
      dimension.data[rowIndex] = info
      dimension.dataIndexes[rowIndex] = indexKey




      /**/
    };
    dimension.getKey = function (code, id) {
      return code.toLowerCase() + ':' + id
    };
    dimension.getDimensionInfo = function (code, id) {
      var k = dimension.getKey(code, id)
      var index = dimension.dataIndexes.indexOf(k)
      if (index == -1) return null
      return dimension.data[index]
    };

    // 新增纬度值
    dimension.addNew = function (code, name) {
      var id = dimension.getNewId()
      dimension.init(code, id, name, '', true)
      // document.write("<BR/>newId="+id);
      return id
    };

    dimension.getNewId = function (code) {
      // document.write("<BR/>"+dimension.maxId);
      dimension.maxId = dimension.maxId + 1
      //document.write("<BR/>" + dimension.maxId);
      return dimension.maxId
    };

    return dimension


  }
}
//GIS
var GisSettingBLL = {
  createNew: function () {
    var bll = {}
    bll.timeArray = new Array() //日期ID文本数组
    bll.regionArray = new Array() //地区ID数组
    bll.otherCodeArray = Array() //除时间和地区纬度外的其它纬度
    bll.otherValueArray = new Array() //出时间和地区外的其它纬度值
    bll.maxValue = NaN //最大值
    bll.minValue = NaN //最小值

    return bll


  }
}

var GisColorBLL = {
  createNew: function () {
    var bll = {}
    bll.colorArray = new Array() //[['aa.png','#cccccc','#dddddd'],[]]
    bll.chartColorArray = new Array()

    bll.init = function () {
      // bll.init1('aa.png', ['#FF0000', '#222222', '#000999', '#003399', '#ffff00', '#999999', '#EACDAD', '#DADDDD', '#EEEECA', '#BBBdBB']);
      bll.colorArray = [
        ['page_pic_clip_image000.png', '#38761D', '#695916', '#9A3C0F', '#CB1F08', '#FB0202', '#C91051', '#88163E', '#591F33', '#5F0A41', '#5D045E'],
        ['page_pic_clip_image001.png', '#FB0202', '#CB1F08', '#9A3C0F', '#695916', '#38761D', '#37940E', '#3FC006', '#06BEC0', '#07A5B3', '#04879F'],
        ['page_pic_clip_image002.png', '#1F497D', '#4F81BD', '#C0504D', '#9BBB59', '#8064A2', '#4bacc6', '#f79646', '#CE6C33', '#E7C841', '#C72740'],
        ['page_pic_clip_image003.png', '#298AFF', '#FF3630', '#712DFF', '#40C8EC', '#F79646', '#3F4545', '#EBBA03', '#F47280', '#00798F', '#4B3478'],
        ['page_pic_clip_image004.png', '#851647', '#C74580', '#42CA46', '#509EC4', '#A77F5E', '#CAB5C8', '#FCC6CD', '#641C1E', '#ED4445', '#E5DCE3'],
        ['page_pic_clip_image005.png', '#ED4C90', '#6574B9', '#FFCD0E', '#EE3324', '#3B2F83', '#6B703D', '#D0D88E', '#474868', '#D85F3F', '#E0D446'],
        ['page_pic_clip_image006.png', '#660033', '#996600', '#660099', '#006633', '#333399', '#E7C841', '#C72740', '#DFD7D1', '#B6A499', '#EDE2AD'],
        ['page_pic_clip_image007.png', '#C41CB0', '#A43B4E', '#CFBAA6', '#788A43', '#5E4D2A', '#349EAD', '#EB844B', '#4A4653', '#CAB5C8', '#FCC6CD'],
        ['page_pic_clip_image008.png', '#3F4545', '#EBBA03', '#F47280', '#00798F', '#4B3478', '#A485B1', '#A3CFD6', '#D9D3CA', '#EBE07D', '#DE9391'],
        ['page_pic_clip_image009.png', '#44649E', '#59754C', '#CE6C33', '#E7C841', '#C72740', '#DFD7D1', '#B6A499', '#EDE2AD', '#F0887F', '#B4C0C2']
      ]
      bll.chartColorArray = [
        ['page_pic_clip_image010.png', '#44649E', '#59754C', '#CE6C33', '#E7C841', '#C72740', '#DFD7D1', '#B6A499', '#EDE2AD', '#F0887F', '#B4C0C2'],
        ['page_pic_clip_image009.png', '#3F4545', '#EBBA03', '#F47280', '#00798F', '#4B3478', '#A485B1', '#A3CFD6', '#D9D3CA', '#EBE07D', '#DE9391'],
        ['page_pic_clip_image008.png', '#CAB5C8', '#FCC6CD', '#641C1E', '#ED4445', '#E5DCE3', '#E0D4CC', '#A9B3BF', '#349EAD', '#EB844B', '#4A4653'],
        ['page_pic_clip_image007.png', '#6B703D', '#D0D88E', '#474868', '#D85F3F', '#E0D446', '#FEC69B', '#ED6961', '#5C96B0', '#B8D97E', '#FEF1BF'],
        ['page_pic_clip_image006.png', '#C41CB0', '#A43B4E', '#CFBAA6', '#788A43', '#5E4D2A', '#349EAD', '#EB844B', '#4A4653', '#CAB5C8', '#FCC6CD'],
        ['page_pic_clip_image005.png', '#660033', '#996600', '#660099', '#006633', '#333399', '#E7C841', '#C72740', '#DFD7D1', '#B6A499', '#EDE2AD'],
        ['page_pic_clip_image004.png', '#ED4C90', '#6574B9', '#FFCD0E', '#EE3324', '#3B2F83', '#6B703D', '#D0D88E', '#474868', '#D85F3F', '#E0D446'],
        ['page_pic_clip_image003.png', '#851647', '#C74580', '#42CA46', '#509EC4', '#A77F5E', '#CAB5C8', '#FCC6CD', '#641C1E', '#ED4445', '#E5DCE3'],
        ['page_pic_clip_image002.png', '#298AFF', '#FF3630', '#712DFF', '#40C8EC', '#F79646', '#3F4545', '#EBBA03', '#F47280', '#00798F', '#4B3478'],
        ['page_pic_clip_image001.png', '#1F497D', '#4F81BD', '#C0504D', '#9BBB59', '#8064A2', '#4bacc6', '#f79646', '#CE6C33', '#E7C841', '#C72740']
      ]
    }
    bll.init1 = function (imagePath, colorArray) {
      var t = new Array()
      t.push(imagePath)
      var ctx = t.concat(colorArray)
      bll.colorArray.push(ctx)
    };
    bll.getColorSchemes = function () {
      var t = new Array()
      for (var i = 0; i < bll.colorArray.length; i++)
        {t.push(bll.colorArray[0]);}
      return t
    };
    bll.getColor = function (schemeIndex, colorIndex) {
      return bll.colorArray[schemeIndex][colorIndex + 1]
    };
    return bll
  }
}

var GisDataInfo = {
  createNew: function () {
    var data = {}
    data.timeArray = new Array() //1级纬度
    data.regionArray = new Array() //2级纬度
    data.otherValueArray = new Array()
    data.gisRegionArray = new Array() //2级纬度
    data.maxValue = NaN
    data.minValue = NaN
    data.data = new Array()
    data.factValueBLL = null

    data.print = function () {
      document.write('<table border=1>')
      for (var i = 0; i < data.data.length; i++) {
        document.write('<tr>')
        for (var j = 0; j < data.data[i].length; j++) {
          document.write('<td>')
          document.write(data.data[i][j])
          document.write('</td>')
        }
        document.write('</tr>')
      }
      document.write('</table>')
    };
    data.groupCount = 5 //默认分组数量
    data.displayPrecision = 2

    data.colorResultArray = new Array() //分组方案
    //data.getColorResultScheme = function() {
    //    return data.colorResultArray;
    //};
    data.getFillColor = function (v) {
      for (var i = 0; i < data.colorResultArray.length; i++) {
        var v1 = parseFloat(v)
        var minValue = parseFloat(data.colorResultArray[i].minValue)
        var maxValue = parseFloat(data.colorResultArray[i].maxValue)
        //if (data.colorResultArray.length - 1 == i) {
        //    if (v1 >= minValue && v1 <= maxValue) {
        //        return data.colorResultArray[i].colorCode;
        //    }
        //}
        //if (v1 >= minValue && v1 < maxValue) {
        if (v1 >= minValue && v1 <= maxValue) {
          return data.colorResultArray[i].colorCode
        }
      }
      return '#FFFFFF';
    }
    //获取一个时间点的数据
    data.getDataByTimeId = function (timeid) {
      var t = parseInt(timeid)
      var index = data.timeArray.indexOf(t)
      if (index > -1) {
        var d = data.data[index]
        var newArray = new Array()
        for (var i = 0; i < data.regionArray.length; i++) {
          newArray[i] = [data.regionArray[i], d[i]]
        }
        return newArray
      }
      return []
    };

    data.colorBLL = GisColorBLL.createNew()
    //自动分组
    data.autoGroup = function (groupCount, schemeIndex) {
      data.colorBLL.init()

      data.colorResultArray = new Array()
      data.groupCount = groupCount

      var per = parseFloat((data.maxValue - data.minValue + 0) / groupCount).toFixed(data.displayPrecision)

      var firstValue = parseFloat(data.minValue).toFixed(data.displayPrecision)
      for (var i = 0; i < groupCount; i++) {
        var groupInfo = GISGroupRangeInfo.createNew()

        groupInfo.minValue = firstValue
        var maxV
        if (i < groupCount - 1)
          {maxV = parseFloat(parseFloat(groupInfo.minValue) + parseFloat(per)).toFixed(data.displayPrecision);}
        else
          {maxV = parseFloat(data.maxValue).toFixed(data.displayPrecision);}
        groupInfo.maxValue = maxV

        groupInfo.text = '大于等于' + firstValue + '并且小于' + groupInfo.maxValue
        var color = data.colorBLL.getColor(schemeIndex, i)
        groupInfo.colorCode = color

        data.colorResultArray.push(groupInfo)
        firstValue = groupInfo.maxValue
      }
      return data.colorResultArray
    };

    // 修改其中一个分组
    data.setGroup = function (index, minValue, maxValue, text, colorCode) {
      if (minValue > maxValue) return false

      data.colorResultArray[index].minValue = minValue
      data.colorResultArray[index].maxValue = maxValue
      data.colorResultArray[index].text = text
      data.colorResultArray[index].colorCode = colorCode

      //console.log(index+'. '+JSON.stringify(data.colorResultArray[index]));
      return true
    };
    // 校验分组
    data.checkGroup = function () {
      for (var i = 0; i < data.groupArray.length - 2; i++) {
        var index = i
        var index1 = i + 1
        if (data.groupArray[index1].minValue < data.groupArray[index].maxValue) {
          return false
        }
      }
      return true

    };
    data.printColorGroupResult = function () {
      var html = '<table border="0" cellspacing="0" cellpadding="2">'
      for (var i = 0; i < data.colorResultArray.length; i++) {
        html += '<tr>'
        html += '<td style="width:30px" bgcolor="' + data.colorResultArray[i].colorCode + '" onclick="changeColor(this)">'
        html += '</td>'
        html += '<td>[<input style="width:50px" type="text" value="' + data.colorResultArray[i].minValue + '"/>,<input style="width:50px" type="text" value="' + data.colorResultArray[i].maxValue + '"/>' + (i < data.colorResultArray.length - 1 ? ')' : ']') + '</td>'
        html += '<td><input style="width:80px" type="text" value="" name="colorgroup_text"/></td>'
        html += '</tr>'
      }
      html += '</table>'
      return html
    }

    data.autoGroupBySort = function (groupCount, schemeIndex, timeid, colorA, colorB) {
      data.colorBLL.init()

      data.colorResultArray = new Array()
      data.groupCount = groupCount

      var gradientColorArray = new Array()
      if (colorA != null && colorB != null) {
        gradientColorArray = jsgradient.generateGradient(colorA, colorB, groupCount)
      }

      /*            48个国家5等分            */
      var newData = data.getDataByTimeId(timeid)
      newData.sort(function (a, b) {
        return parseFloat(b[1]) - parseFloat(a[1])
      })

      //数据去重
      var distinctDataArray = new Array()
      for (var i = 0, len = newData.length; i < len; i++) {
        if (distinctDataArray.indexOf(parseFloat(newData[i][1])) == -1)
          {distinctDataArray.push(parseFloat(newData[i][1]));}
      }
      // 如果去重后的数值个数小于等于分组个数，则分组区间改为单个数值显示
      if (distinctDataArray.length <= groupCount) {
        for (var i = 0, len = distinctDataArray.length; i < len; i++) {
          var groupInfo = GISGroupRangeInfo.createNew()
          var fvalue = parseFloat(distinctDataArray[i]).toFixed(data.displayPrecision)
          groupInfo.maxValue = fvalue
          groupInfo.minValue = fvalue
          groupInfo.text = '等于' + fvalue
          var color = gradientColorArray.length == groupCount ? gradientColorArray[i] : data.colorBLL.getColor(schemeIndex, i)
          groupInfo.colorCode = color
          data.colorResultArray.push(groupInfo)
        }
      } else {
        // 每组个数
        var baseNum = newData.length % groupCount == 0 ? newData.length / groupCount : parseInt(newData.length / groupCount) + 1
        //console.log('baseNum:' + baseNum);
        for (var i = 0; i < groupCount; i++) {
          var groupInfo = GISGroupRangeInfo.createNew()
          /*  //升序
              var minV = parseFloat(newData[i * baseNum][1]).toFixed(data.displayPrecision);
              groupInfo.minValue = minV;
              var maxV;
              if (i < groupCount - 1)
                  maxV = parseFloat(newData[(i + 1) * baseNum - 1][1]).toFixed(data.displayPrecision);
              else {
                  var value=0;
                  for (var n = newData.length - 1; n > 0; n--) { if (newData[n][1] != undefined) { value = newData[n][1];break; } }
                  maxV = parseFloat(value).toFixed(data.displayPrecision);
              }
              groupInfo.maxValue = maxV;
              groupInfo.text = "大于等于" + groupInfo.minValue + "并且小于等于" + groupInfo.maxValue;
          */
          //降序
          var maxV = parseFloat(newData[i * baseNum][1]).toFixed(data.displayPrecision)
          groupInfo.maxValue = maxV

          var minV
          if (i < groupCount - 1) {
            minV = parseFloat(newData[(i + 1) * baseNum - 1][1]).toFixed(data.displayPrecision)
            if (minV == 0) {
              var vv = 0
              for (var nn = (i + 1) * baseNum - 1; nn > 0; nn--) {
                if (newData[nn][1] != 0) {
                  vv = newData[nn][1]
                  break;
                }
              }
              minV = parseFloat(vv).toFixed(data.displayPrecision)
            }
          } else {
            var value = 0
            for (var n = newData.length - 1; n > 0; n--) {
              if (newData[n][1] != undefined) {
                value = newData[n][1]
                break;
              }
            }
            minV = parseFloat(value).toFixed(data.displayPrecision)
          }

          groupInfo.minValue = minV

          groupInfo.text = '大于等于' + groupInfo.minValue + '并且小于等于' + groupInfo.maxValue

          var color = gradientColorArray.length == groupCount ? gradientColorArray[i] : data.colorBLL.getColor(schemeIndex, i)
          groupInfo.colorCode = color

          //console.log('groupInfo:' +JSON.stringify(groupInfo));

          data.colorResultArray.push(groupInfo)
        }
      }
      return data.colorResultArray
    };

    data.printColorGroupResult2 = function () {
      var html = '<table border="0" cellspacing="0" cellpadding="2">'
      for (var i = 0; i < data.colorResultArray.length; i++) {
        var result = data.colorResultArray[i]
        html += '<tr>'
        html += '<td style="width:25px;padding:0 1px 0 1px" bgcolor="' + result.colorCode + '" onclick="changeColor(this)">'
        html += '</td>'
        if (result.text == '等于' + result.minValue) {
          html += '<td><span>' + result.minValue + '</span></td>'
        } else {
          html += '<td>[<input style="width:49px" type="text" value="' + result.minValue + '"/>,<input style="width:49px" type="text" value="' + result.maxValue + '"/>]</td>'
          html += '<td><input style="width:65px" type="text" value="" name="colorgroup_text"/></td>'
        }
        html += '</tr>'
      }
      html += '</table>'
      return html
    };

    data.schemeArray = new Array()

    data.schemeGroup = function (factValueBLL, timeid, startColorStr, endColorStr) {
      if (colorCount == 0) colorCount = data.regionArray.length

      var colorArray = jsgradient.generateGradient(startColorStr, endColorStr, data.regionArray.length)
      var regionValue = data.getDataByTimeId(timeid)

      var temp1 = new Array()
      var temp2 = new Array()
      for (i = regionValue.length - 1; i > -1; i--) {
        if (isNaN(regionValue[i][1])) {
          temp1.push(regionValue[i])

        } else {
          temp2.push(regionValue[i])
        }
      }
      regionValue = temp1.concat(temp2)

      regionValue.sort(function (x, y) {
        if (x[1] == null || y[1] == null) return -1
        if (isNaN(x[1]) || isNaN(y[1])) return -1
        return x[1] - y[1]
      })

      data.colorResultArray = new Array()
      data.groupCount = regionValue.length

      for (var i = 0; i < data.groupCount; i++) {
        if (isNaN(regionValue[i][1])) continue

        var groupInfo = GISGroupRangeInfo.createNew()
        groupInfo.minValue = regionValue[i][1]
        groupInfo.maxValue = regionValue[i][1]
        groupInfo.text = factValueBLL.getCodeValueText('state', regionValue[i][0])
        groupInfo.colorCode = colorArray[i]
        data.colorResultArray.push(groupInfo)
      }
      return data.colorResultArray
    };

    data.printSchemeGroupResult = function () {
      var html = '<table border="0" cellspacing="0" cellpadding="2">'
      for (var i = 0; i < data.colorResultArray.length; i++) {
        html += '<tr>'
        html += '<td style="width:30px" bgcolor="' + data.colorResultArray[i].colorCode + '" onclick="changeColor(this)">'
        html += '</td>'
        html += '<td>' + data.colorResultArray[i].text + '</td>'
        html += '</tr>'
      }
      html += '</table>'
      return html
    }
    return data
  }
}
var GISGroupRangeInfo = {
  createNew: function () {
    var info = {}
    info.minValue = NaN
    info.maxValue = NaN
    info.text = '';
    info.colorCode = '#FFFFFF';
    return info

  }

}
var FactValueMatrix = {
  createNew: function () {
    var matrix = {}
    matrix.xAxisCodes = new Array()
    matrix.yAxisCodes = new Array()
    matrix.xAxisValues = new Array()
    matrix.yAxisValues = new Array()
    matrix.displayPrecision = 2

    //设置X轴 codes:time,region   arrayValues:[[2003，2004]，[2，4，5]]
    matrix.setXAxis = function (codes, arrayValues, filterArray, sortArray) {
      matrix.xAxisCodes = codes.split(',')
      var t = matrix.xAxisValues = matrix.setAxis(codes, arrayValues, sortArray)
      matrix.xAxisValues = matrix.filterAxis(t, matrix.xAxisCodes, filterArray)

    };
    // 设置Y轴
    // codes:time,region   arrayValues:[[2003，2004]，[2，4，5]]
    matrix.setYAxis = function (codes, arrayValues, filterArray, sortArray) {
      // alert(arrayValues.length);
      matrix.yAxisCodes = codes.split(',')
      var t = matrix.setAxis(codes, arrayValues, sortArray)
      matrix.yAxisValues = matrix.filterAxis(t, matrix.yAxisCodes, filterArray)


    };
    // 获取2数组交集
    matrix.getInArray = function (arr1, arr2) {
      if (arr1 == null || arr2 == null) return null
      // document.write("<BR/>arr1:" + arr1);
      // document.write("<BR/>arr2:" + arr2);

      var hash = {}
      var intersect = {}
      var res = []
      for (var i = 0, l = arr1.length; i < l; i++)
        {hash[arr1[i]] = true;}
      for (var i = 0, l = arr2.length; i < l; i++)
        {hash[arr2[i]] && (intersect[arr2[i]] = true);}
      for (var k in intersect)
        {res.push(k);}

      /// document.write("<BR/>res:" + res);
      return res
    };
    // arrayValue,依据codes的顺序的多维数组[[2003，2004]，[2，4，5]]
    matrix.setAxis = function (codes, arrayValue, sortArray) {
      //  alert(sortArray[1][0]);

      var array = codes.split(',')
      //设置排序
      if (sortArray != null && sortArray.length > 0) {
        for (var kk1 = 0; kk1 < array.length; kk1++) {
          //  var c1 = new Array();
          for (var kk2 = 0; kk2 < sortArray.length; kk2++) {
            if (sortArray[kk2][0].toLowerCase() == array[kk1].toLowerCase()) {
              // alert(sortArray[kk2][0].toLowerCase() + ' ' + array[kk1].toLowerCase());
              // alert(sortArray[kk2][0].toLowerCase());
              var a1 = new Array()
              for (var kk3 = 0; kk3 < sortArray[kk2][1].length; kk3++) {
                // alert(sortArray[kk2][1][kk3]);
                if (arrayValue[kk1].indexOf(parseInt(sortArray[kk2][1][kk3])) > -1) {
                  a1.push(sortArray[kk2][1][kk3])
                }
              }
              // var a1 = sortArray[kk2][1];
              // alert(a1);
              // var a2 = getInArray(a1, arrayValue[kk1]);
              arrayValue[kk1] = a1
              break;
            }
          }
        }
      }

      // 初始化第一个纬度
      var preArray = new Array()
      for (var i = 0; i < arrayValue[0].length; i++) {
        preArray[i] = new Array()
        preArray[i][0] = arrayValue[0][i]
      }

      // 从第二个纬度开始
      var kk = 1
      while (true) {
        if (kk == array.length) break

        var nextArray = new Array()
        var j
        var k
        var h = 0

        for (k = 0; k < preArray.length; k++) {
          for (j = 0; j < arrayValue[kk].length; j++) {
            var l = preArray[k].length
            var c = 0
            nextArray[h] = new Array()

            for (c = 0; c < preArray[k].length; c++) {
              nextArray[h][c] = preArray[k][c]
            }

            nextArray[h][l] = arrayValue[kk][j]


            h = h + 1
          }
        }
        preArray = []
        preArray = nextArray
        nextArray = []
        kk = kk + 1
      }
      return preArray
    };

    // 筛选纬度 filterCodes:["time","indicator"] filterArray[["time",1,2,3],[["indicator",1,2,3]]]
    matrix.filterAxis = function (axisValues, filterCodes, filterArray) {
      if (filterArray == null || filterArray.length == 0) return axisValues

      // alert("filterArray:" +filterArray);

      var f1 = new Array()
      var kk = 0
      var i, j, k
      var hasFilter = false
      for (i = 0; i < filterCodes.length; i++) {
        f1[i] = new Array()
        kk = 0
        for (j = 0; j < filterArray.length; j++) {
          if (filterArray[j] == null) continue
          if (filterArray[j][0].toLowerCase() == filterCodes[i].toLowerCase()) {
            for (var cc = 1; cc < filterArray[j].length; cc++) {
              f1[i][cc - 1] = filterArray[j][cc]
            }
            // f1[i] = filterArray[j].splice(1);
            hasFilter = true
            break;
          }
        }
      }

      if (!hasFilter) return axisValues

      var newItems = new Array()
      kk = 0
      for (k = 0; k < axisValues.length; k++) {
        var hasTrue = true
        for (i = 0; i < filterCodes.length; i++) {
          if (f1[i].length == 0) continue

          var c = 0

          var hasTrue1 = false //数组IndexOf无效
          for (c = 0; c < f1[i].length; c++) {
            if (axisValues[k][i] == null) {
              hasTrue1 = false
              continue;
            }
            if (f1[i][c] == axisValues[k][i]) {
              hasTrue1 = true
              break; ;
            }
          }
          // document.write(hasTrue1);
          if (!hasTrue1) {
            hasTrue = false
            continue;
          }
          //      document.write("<BR/>******************");
        }

        // alert('axisValues' +axisValues[k]);

        if (hasTrue) {
          newItems[kk] = axisValues[k]
          kk++
        }
      }
      // alert("newItems:"+newItems);
      // document.write('<br/>newItems' + newItems);

      // document.write('<br/>**************************');
      return newItems

    };

    // 矩阵的X轴长度
    matrix.getXLength = function () {
      return matrix.xAxisValues.length
    };
    // 矩阵的Y轴长度
    matrix.getYLength = function () {
      return matrix.yAxisValues.length
    };
    // 数据行
    matrix.data = new Array()
    //表头
    matrix.header = new Array()

    matrix.filterArray = new Array()

    //设置值
    matrix.setValue = function (row, col, factValue) {
      if (matrix.data[row] == null) matrix.data[row] = new Array()
      matrix.data[row][col] = factValue
      // console.log('matrix.setValue ', factValue)
    };
    // 设置表头
    matrix.setHeader = function (row, col, dimensionInfo) {
      if (matrix.header[row] == null) matrix.header[row] = new Array()
      matrix.header[row][col] = dimensionInfo
    };
    // 多表头文本
    matrix.title = '';
    matrix.setTitle = function (text) {
      matrix.title = text
    };
    matrix.getTitle = function () {
      return matrix.title
    };
    // 排序
    matrix.sort = function (col, isasc) {
      var i

      if (col >= matrix.xAxisCodes.length) {
        var newData = Array()
        var NanData = Array()
        for (i = 0; i < matrix.data.length; i++) {
          if (matrix.data[i][col] == null ||
            matrix.data[i][col].FactValue == null ||
            matrix.data[i][col].FactValue == NaN) {
            NanData.push(matrix.data[i])
          } else {
            newData.push(matrix.data[i])
          }
        }
        newData.sort(function (a, b) {
          if (isasc) {
            return a[col].FactValue - b[col].FactValue
          } else {
            return b[col].FactValue - a[col].FactValue
          }
        })
        matrix.data = NanData.concat(newData)
      } else {
        // matrix.data.sort(function(a, b) {
        //     var x = a[col].name;
        //     var y = b[col].name;
        //     var result = (x[0] == y[0]) ? (x.localeCompare(y)) : (x[0].localeCompare(y[0]));
        //     if (isasc)
        //         return result;
        //     else {
        //         return -1 * result;
        //     }
        // });
        matrix.data.sort(function (a, b) {
          if (isasc)
            {return a[col].OrderNumber - b[col].OrderNumber;}
          else {
            return b[col].OrderNumber - a[col].OrderNumber
          }
        })
      }
    }

    //新增行索引
    matrix.addNewXAxis = function (array) {
      matrix.xAxisValues.push(array)
    };
    // 新增行索引
    matrix.addNewYAxis = function (array) {
      matrix.yAxisValues.push(array)
    };
    // 获取值
    matrix.getFactValue = function (row, col) {
      return matrix.data[row][col]
    };
    // 通过需要索引获取值
    matrix.getValueByNo = function (row, col) {
      // document.write("<BR/>row=" + row + ',col=' + col);
      row = row - 1
      col = matrix.xAxisCodes.length + col
      var d = matrix.getFactValue(row, col)
      //document.write("<BR/>row=" + row + ',col=' + col);
      // document.write("<BR/>d=" +d);
      if (d != undefined && d != null && d.FactValue != null) return d.FactValue
      return NaN
    };

    // 是否显示用户修改数据
    matrix.showUser = true

    return matrix
  }

}


const FactValueBLL = {
  createNew: function () {
    var bll = {}
    bll.values = Array() //数据
    bll.indexBLL = FactValueIndex.createNew()
    bll.dimensionBLL = DimenensionBLL.createNew()
    bll.displayPrecision = 2

    bll.gisCode = 'state' //"region";

    //加载数据
    bll.init = function (values) {
      for (var i = 0; i < values.length; i++) {
        var factValue = FactValueInfo.createNew()
        factValue.Id = values[i].Id
        factValue.FactValue = values[i].FactValue
        bll.initFactValue(i, factValue)
      }
      // bll.values = values;
      // bll.indexBLL.init(values);
    }

    bll.maxValue = NaN
    bll.minValue = NaN

    bll.initFactValue = function (row, factvalue) {
      // document.write(factvalue.FactValue);
      // if (factvalue != '**') {
      // 最大值和最小值
      if (isNaN(bll.maxValue)) {
        bll.maxValue = factvalue.FactValue
        bll.minValue = factvalue.FactValue
      }
      if (!isNaN(factvalue) && bll.maxValue < factvalue.FactValue) bll.maxValue = factvalue.FactValue
      if (!isNaN(factvalue) != null && bll.minValue > factvalue.FactValue) bll.minValue = factvalue.FactValue
      // }
      // console.log('bll.initFactValue', factvalue.FactValue);
      bll.values.push(factvalue)
      bll.indexBLL.loadIndex(row, factvalue.Id)
    };

    bll.initDimensions = function (dimensionvalues) {
      var i
      for (i = 0; i < dimensionvalues.length; i++) {
        // document.write(dimensionvalues[i].DimensionCode);
        bll.indexBLL.initCodeValue(dimensionvalues[i].DimensionCode, dimensionvalues[i].Id)

        bll.dimensionBLL.init(dimensionvalues[i].DimensionCode,
          dimensionvalues[i].Id,
          dimensionvalues[i].Name,
          dimensionvalues[i].Explanation, false, dimensionvalues[i].OrderNumber
        )
      }
    }
    //array: [["indicator", "指标"], ["region", "地区"], ["time", "时间"]];
    bll.initCodeText = function (array) {
      var i
      for (i = 0; i < array.length; i++) {
        bll.indexBLL.initCodeText(array[i][0], array[i][1])
      }
    }
    //初始化纬度信息
    bll.initCodeValues = function (code, codeValueArray) {
      bll.indexBLL.initCodeValues(code, codeValueArray)
    };
    bll.setDisplayPrecision = function (precision) {
      bll.displayPrecision = precision
    };
    // 输入Id，返回事实表对象
    bll.getFactValueById = function (id) {
      var f = bll.indexBLL.getIndexById(id)

      if (f == -1) return null

      return bll.values[f]
    };
    // 输入Id，返回事实表数据
    bll.getValueById = function (id) {
      //   id = id.toLowerCase();
      var f = bll.getFactValueById(id)
      if (f == null) return NaN
      if (f == -1) return NaN
      return f.FactValue
    };
    // 获取事实表数据 array:[["region","1"],["indicator","2"],["time","2001"]] isuer:true
    bll.getValueByKeys = function (array, isuser) {
      var rowIndexArray = bll.indexBLL.getFactValueRowIndexByKeys(array)
      return rowIndexArray
    };

    var fArray = new Array()
    //清空
    bll.clearFilter = function () {
      for (var i = 0; i < fArray.length; i++) {
        fArray.pop()
      }
      // fArray = new Array();
    }
    //设置过滤纬度值  code:time array:[2001,2003]
    bll.setFilter = function (code, array) {
      var index = bll.indexBLL.getCodeIndex(code)

      if (fArray[index] == null) {
        fArray[index] = new Array()
        fArray[index][0] = code
      }

      for (var i = 0; i < array.length; i++)
        {fArray[index].push(array[i]);}
      // return bll.filterArray();
    }

    //获取过滤条件
    bll.getFilterArray = function () {
      // var temp = new Array();
      // for (var i = 0; i < bll.filterArray.length; i++) {
      //    temp[i]=bll.filterArray[i];
      // }
      return fArray
    };
    // sortArray=[["indicator"],[2,4,5]]
    // 创建矩阵
    bll.createMatrix = function (xcodes, ycodes, filterArray, isUser, sortArray) {
      // alert(sortArray);
      if (sortArray == undefined) sortArray = new Array()
      var matrix = FactValueMatrix.createNew()
      matrix.showUser = isUser

      matrix.setXAxis(xcodes, bll.getCodeValues(xcodes), filterArray, sortArray)
      matrix.setYAxis(ycodes, bll.getCodeValues(ycodes), filterArray, sortArray)

      //排序
      matrix.displayPrecision = bll.displayPrecision
      matrix.filterArray = filterArray

      //设置Title
      var t = '(';
      for (var i = 0; i < matrix.xAxisCodes.length; i++) {
        if (i > 0) t += ','
        t += bll.indexBLL.getCodeText(matrix.xAxisCodes[i])
      }
      t += ')/('
      for (var i = 0; i < matrix.yAxisCodes.length; i++) {
        if (i > 0) t += ','
        t += bll.indexBLL.getCodeText(matrix.yAxisCodes[i])
      }
      t += ')'
      matrix.setTitle(t)

      //创建数据表
      var row, col
      for (row = 0; row < matrix.yAxisCodes.length; row++) {
        var code = matrix.yAxisCodes[row]
        //表前列
        var j
        for (j = 0; j < matrix.xAxisCodes.length; j++) {
          matrix.setHeader(row, j, null)
        }

        var startPos = matrix.xAxisCodes.length

        for (col = 0; col < matrix.yAxisValues.length; col++) {
          var codeValue = matrix.yAxisValues[col][row]
          var dimensionInfo = bll.dimensionBLL.getDimensionInfo(code, codeValue)
          matrix.setHeader(row, startPos + col, dimensionInfo)

        }
      }

      if (matrix.yAxisCodes[0] == 'time_id') {
        let timeValues = matrix.header[0]
        timeValues.splice(0, matrix.xAxisCodes.length)
        timeValues = timeValues.sort(function (a, b) {
          return a.OrderNumber - b.OrderNumber
        })
        matrix.header[0] = new Array()
        matrix.yAxisValues = new Array()
        for (var i = 0; i < matrix.xAxisCodes.length; i++) {
          matrix.header[0].push(null)
        }
        for (var i = 0; i < timeValues.length; i++) {
          matrix.header[0].push(timeValues[i])
          matrix.yAxisValues.push([timeValues[i].id])
        }
      }

      // 设置数据
      bll.setMatrixData(matrix)

      return matrix
    };

    // 设置矩阵数据行
    bll.setMatrixDataRow = function (matrix, row) {
      var col, j, codeValue, code
      var rowArray = new Array()
      for (col = 0; col < matrix.xAxisCodes.length; col++) {
        codeValue = matrix.xAxisValues[row][col]
        code = matrix.xAxisCodes[col]
        rowArray.push([code, codeValue])

        var dimensionInfo = bll.dimensionBLL.getDimensionInfo(code, codeValue)

        matrix.setValue(row, col, dimensionInfo)
      }

      var startPos = matrix.xAxisCodes.length

      for (col = 0; col < matrix.yAxisValues.length; col++) {
        var newArray = new Array()
        for (j = 0; j < matrix.yAxisCodes.length; j++) {
          code = matrix.yAxisCodes[j]
          codeValue = matrix.yAxisValues[col][j]
          newArray.push([code, codeValue])
        }
        var attrArray = newArray.concat(rowArray)
        var rowIndex = bll.indexBLL.getFactValueRowIndex(attrArray, matrix.showUser)
        var fact = null
        if (rowIndex > -1) {
          fact = bll.values[rowIndex]
          if (fact == null) {
            // console.log('setMatrixDataRow rowIndex fact', fact);
          }
          var hasUser = false
          var id = fact.Id
          if (id.indexOf('userdata:true') > -1) hasUser = true
        } else {
          // console.log('setMatrixDataRow rowIndex', rowIndex);
        }
        matrix.setValue(row, startPos + col, fact)
        fact = null
        attrArray = null
        newArray = null
        //html += '<td><div head=false data=true id="' + fact.id + '" ' + (hasUser ? 'style="color:red"' : '') + ' pos="' + row + ',' + col + '" userdata=' + isUser + '>' + fact.factvalue + '</div></td>';
      }
    }
    //设置矩阵数据
    bll.setMatrixData = function (matrix) {
      matrix.data = new Array()
      for (var row = 0; row < matrix.xAxisValues.length; row++) {
        bll.setMatrixDataRow(matrix, row)
      }
    }

    bll.getSortArray = function (requestString) {
      var result = new Array()
      var bb = requestString.split('_')
      if (bb.length > 0) {
        for (var i = 0; i < bb.length; i++) {
          var cc = bb[i].split(':')
          if (cc.length > 0) {
            result[i] = new Array()
            result[i][0] = cc[0]
            result[i][1] = cc[1].split(',')

          }
        }
      }
      return result
    };

    // 设置表头
    bll.appendHeader = function (matrix, array) {
      var kk = matrix.header[0].length
      for (var row = 0; row < matrix.yAxisCodes.length; row++) {
        var code = matrix.yAxisCodes[row]
        var codeValue = array[row]
        // alert(dimensionInfo.name);
        var dimensionInfo = bll.dimensionBLL.getDimensionInfo(code, codeValue)

        matrix.setHeader(row, kk, dimensionInfo)
      }
    }
    bll.appendDataRow = function (matrix, array) {
      var i

      for (i = 0; i < matrix.data.length; i++) {
        matrix.data[i].push(array[i])
      }
    }

    //获取数据,输入id,和是否用户数据
    bll.getValueByIdWidthUserData = function (id, userdata) {
      var newId = id
      if (userdata) newId = id.replace('userdata:false', 'userdata:true')
      else {
        newId = id.replace('userdata:true', 'userdata:false')
      }
      //    alert(newId);
      var f = bll.getValueById(newId)
      return f

    };
    // 新增用户数据
    bll.addUserData = function (id, factvalue) {
      id = id.replace('userdata:false', 'userdata:true')
      var index = bll.indexBLL.getIndexById(id)

      if (index > -1) {
        bll.values[index].FactValue = factvalue
      } else {
        var factValue = FactValueInfo.createNew()
        factValue.Id = id
        factValue.FactValue = factvalue
        bll.initFactValue(bll.values.length, factValue)
      }
    }

    bll.getCodes = function () {
      //  alert('ddd');
      return bll.indexBLL.getCodes()
    };
    // 依据codes的顺序，比如输入time，region 则返回[[2003，2004]，[2，4，5]]
    bll.getCodeValues = function (codes) {
      var array = codes.split(',')

      var arrayValue = new Array()
      var i
      for (i = 0; i < array.length; i++) {
        arrayValue[i] = bll.indexBLL.getCodeValues(array[i])
      }
      return arrayValue
    };

    // 获取行列计算输入的Title列表
    bll.getTitleInput = function (matrix, axis) {
      var inputArray = new Array()
      var i
      var code, text
      if (axis == 'row') {
        for (i = 0; i < matrix.xAxisCodes.length; i++) {
          code = matrix.xAxisCodes[i]
          text = bll.indexBLL.getCodeText(code)
          inputArray.push(text)
        };
      };
      if (axis == 'col') {
        for (i = 0; i < matrix.yAxisCodes.length; i++) {
          code = matrix.yAxisCodes[i]
          text = bll.indexBLL.getCodeText(code)
          inputArray.push(text)
        };
      };
      return inputArray
    };

    bll.printMatrix = function (matrix) {
      var html = '<table border=1>'
      var i
      var row, col

      //序号行

      html += '<tr name="no" >'
      html += '<td colspan=' + (matrix.xAxisCodes.length + 1) + '>&nbsp;</td>'

      for (col = 0; col < matrix.header[0].length - matrix.xAxisCodes.length; col++) {
        html += '<td name="no">'
        var colNo = (col + 1)
        html += 'R' + (colNo >= 10 ? colNo : '0' + colNo)
        html += '</td>'

      }
      html += '</tr>'


      //表头
      for (row = 0; row < matrix.header.length; row++) {
        html += '<tr>'
        //序号列
        html += '<td name="no" ></td>'
        for (col = 0; col < matrix.header[row].length; col++) {
          // document.write('<BR/>' + matrix.header[row]);
          if (col == 0 && row == 0) {
            html += '<td id="title" rowspan="' + matrix.yAxisCodes.length + '" colspan="' + matrix.xAxisCodes.length + '">' + matrix.getTitle() + '</td>'
          } else {
            if (col < matrix.xAxisCodes.length) {
              continue
            } else {
              // document.write("<BR/>col=" + col);
              html += '<td>'
              var d = matrix.header[row][col]
              if (d != null) {
                html += '<div id="' + d.dimensionCode + '_' + d.id + '" >'
                html += d.name
                if (d.Explanation != null && d.Explanation != '') {
                  html += '<span title="' + d.Explanation + '">?</span>'
                }
                html += '</div>'
                if (row == matrix.header.length - 1) {
                  html += '<div>^</div>'
                }
              } else {
                if (col == 0 && row == 0) {
                  html += matrix.getTitle()
                }
              }
              html += '</td>'
            }
          }
        }
        html += '</tr>'
      }

      for (row = 0; row < matrix.data.length; row++) {
        html += '<tr>'
        //序号列
        var rowNo = (row + 1)
        html += '<td name="no" >C' + (rowNo >= 10 ? rowNo : '0' + rowNo) + '</td>'

        for (col = 0; col < matrix.data[row].length; col++) {
          html += '<td>'
          var d = matrix.data[row][col]
          if (d != null) {
            if (col < matrix.xAxisCodes.length) {
              html += '<div id="' + d.dimensionCode + '_' + d.id + '">' + d.name + '</div>'
            } else {
              var userdata = d.Id.indexOf('userdata:true') != -1;
              // if (d.FactValue!=NaN)
              html += '<div id="' + d.Id + '" ' + (userdata ? 'style="color:red"' : '') + ' hasUser=' + (userdata ? 'true' : 'false') + '>' + d.FactValue + '</div>'

              //                            html += '<div id="' + d.Id + '" ' + (userdata ? 'style="color:red"' : '') + ' hasUser=' + (userdata ? 'true' : 'false') + '>' + parseFloat(d.FactValue).toFixed(matrix.displayPrecision) + '</div>';
            }
          }

          html += '</td>'
        }
        html += '</tr>'
      }

      html += '</table>'
      document.write(html)
      return html


    };

    // 生成表格表头 thead
    bll.printMatrixHeader = function (matrix) {
      // var t = '<span>(</span>';
      // // var t = '<table border="0" celllpadding="0" cellspacing="0" class="table-header"><tr><td>(</td>';
      // for (var i = 0; i < matrix.xAxisCodes.length; i++) {
      //     if (i > 0) t += '<span>,</span>';
      //     t += '<span class="icon-datasort" data-col="' + i + '">' + bll.indexBLL.getCodeText(matrix.xAxisCodes[i]) + '<i class="el-icon-d-caret"></i></span>';
      //     // t += '<td>' + bll.indexBLL.getCodeText(matrix.xAxisCodes[i]) + '</td><td><div class="data-icon-sort" style="float:left"><div class="data-icon-sort-asc" title="升序" onclick="sort(' + i + ',true)"></div><div class="data-icon-sort-desc" title="降序" onclick="sort(' + i + ',false)"></div></div></td>';
      // }
      // t += '<span>)/(</span>';
      // for (var i = 0; i < matrix.yAxisCodes.length; i++) {
      //     if (i > 0) t += '<span>,</span>';
      //     t += '<span>' + bll.indexBLL.getCodeText(matrix.yAxisCodes[i]) + '</span>';
      // }
      // t += '<span>)</span>';
      // var title = t;

      var html = ''
      var i
      var row; var col; var col1; var ccol = 0

      //表头
      for (row = 0; row < matrix.header.length; row++) {
        html += '<tr class="row-header">'

        var _headerCols = matrix.header[row]

        for (col = 0; col < _headerCols.length; col++) {
          if (col < matrix.xAxisCodes.length) {
            if (col < matrix.xAxisCodes.length - 1 && row < matrix.yAxisCodes.length - 1) {
              html += '<td id="title"></td>'
              continue;
            }

            var _title = ''
            if (col == matrix.xAxisCodes.length - 1 && row < matrix.yAxisCodes.length - 1) {
              _title = bll.indexBLL.getCodeText(matrix.yAxisCodes[row])

              html += '<td id="title">' + _title + '</td>'
              continue;
            }

            if (matrix.xAxisCodes.length == 1) {
              _title = '<span>' + bll.indexBLL.getCodeText(matrix.yAxisCodes[row]) + '</span>'
              _title = (row < matrix.yAxisCodes.length - 1) ? _title : '<span>(</span><span class="icon-datasort" data-col="0">' + bll.indexBLL.getCodeText(matrix.xAxisCodes[0]) + '<i class="el-icon-d-caret"></i></span><span>)/(</span>' + _title + '<span>)</span>'
            } else {
              _title = '<span class="icon-datasort" data-col="' + col + '">' + bll.indexBLL.getCodeText(matrix.xAxisCodes[col]) + '<i class="el-icon-d-caret"></i></span>'
              _title = (col < matrix.xAxisCodes.length - 1) ? _title : '<span>(</span>' + _title + '<span>)/(</span><span>' + bll.indexBLL.getCodeText(matrix.yAxisCodes[row]) + '</span><span>)</span>'
            }
            html += '<td id="title">' + _title + '</td>'
          } else {
            // document.write("<BR/>col=" + col);
            var d = _headerCols[col]
            if (d != null) {
              var colspan = 1
              //判断是否是最后一行，不是则合并列
              if (row < matrix.header.length - 1) {
                // 获取colspan
                for (col1 = col + 1; col1 < _headerCols.length; col1++) {
                  var d1 = _headerCols[col1]
                  if (d1 == null || d1.id != d.id) {
                    break
                  }
                  colspan = colspan + 1
                }
              }

              if (colspan > 1) {
                html += '<td colspan=' + colspan + '>'
              } else {
                html += '<td' + (d.isNewData ? ' class="clear-col" ccol="' + (ccol++) + '"' : '') + '>'
              }
              // html += d.OrderNumber;
              if (d.Explanation != null && d.Explanation != '') {
                // html += '<td><div class="data-icon-tip" title="' + d.Explanation + '"></div></td>';
                html += '<span class="icon-dataintro" title="' + d.Explanation + '"><i class="el-icon-info"></i></span>'
              }
              // html += '<table border="0" celllpadding="0" cellspacing="0" align="center" class="table-header"><tr><td><div id="' + d.dimensionCode.toLowerCase() + '_' + d.id + '">' + d.name + '</div></td>';
              var clearComputeHtml = d.isNewData ? '<span class="btn-clear" title="清除该列计算" type="col" ><i class="el-icon-delete"></i></span>' : ''
              var sortAttr = (row == matrix.header.length - 1) ? ' class="icon-datasort" data-col="' + col + '" ' : ''
              var dvName = d.name.replace(/ /g, '')
              var wordNum = 10
              if (colspan == 1 && dvName.length > wordNum && dvName.indexOf('[') > 0) {
                var _i = dvName.indexOf('[')
                dvName = dvName.slice(0, _i) + '<br>' + dvName.slice(_i)
              } else if (colspan == 1 && dvName.length > wordNum && !(dvName.length == wordNum + 1 && dvName.substring(wordNum) == ')')) {
                var _name = ''
                var rowCount = Math.ceil(dvName.length / wordNum)
                if (dvName.slice(wordNum * (rowCount - 1)).length < 4) rowCount--
                for (var r1 = 0; r1 < rowCount; r1++) {
                  if (r1 < rowCount - 1) {
                    _name += dvName.slice(wordNum * r1, wordNum * (r1 + 1)) + '<br>' //dvName.substring(wordNum * r, wordNum);
                  } else {
                    _name += dvName.slice(wordNum * r1) //dvName.substring(wordNum * r);
                  }
                }
                dvName = _name
              }
              html += '<span id="' + d.dimensionCode.toLowerCase() + '_' + d.id + '" ' + sortAttr + '>' + dvName + (sortAttr != '' ? '<i class="el-icon-d-caret"></i>' : '') + '</span>'
              html += clearComputeHtml
              // if (row == matrix.header.length - 1) {
              //     html += '<td><div class="data-icon-sort"><div class="data-icon-sort-asc" title="升序" onclick="sort(' + col + ',true)"></div><div class="data-icon-sort-desc" title="降序" onclick="sort(' + col + ',false)"></div></div></td>';
              // }
              // html += '</tr></table></td>';
              html += '</td>'

              if (row < matrix.header.length - 1 && col < col1 - 1) {
                col = col1 - 1
                continue;
              }
            } else {
              html += '<td>'
              //if (col == 0 && row == 0) {

              //    html += title;
              //}
              html += '</td>'
            }
          }
        }
        html += '</tr>'
      }
      return '<thead>' + html + '</thead>'
    };
    // 生成表格数据 tbody
    bll.printMatrixData = function (matrix) {
      var html = '';
        var trHtml = ''
      var i
      var row, col, ccol

      for (row = 0; row < matrix.data.length; row++) {
        var tempId = new Array()

        for (var kk = 0; kk < matrix.xAxisCodes.length; kk++) {
          tempId.push([matrix.xAxisCodes[kk], matrix.xAxisValues[row][kk]])
        }

        trHtml = '<tr class="datarow">'
        //序号列
        // var rowNo = (row + 1);
        // html += '<td name="no" style="display:none" >C' + (rowNo >= 10 ? rowNo : '0' + rowNo) + '</td>';
        ccol = 0
        for (col = 0; col < matrix.data[row].length; col++) {
          var d = matrix.data[row][col]
          var newDataStyle = ''
          try {
            if (d == null)
              {d = {
                name: '',
                Id: '_userdata:true_',
                Explanation: '',
                isNewData: true,
              };}
            // if (!(d.isNewData == undefined || d.isNewData != null || !d.isNewData)) newDataStyle = ' class="red"';
            if (d.ComputeDel != undefined && d.ComputeType != undefined)
              {newDataStyle = ' class="data-' + d.ComputeType + '" ';}
          } catch (e) {
            console.log('isNewData Error:', d, e)
          }
          var clearClass = (d.isNewData ? ' clear-col' : '')
          var clearAttr = (col > matrix.xAxisCodes.length && d.isNewData ? ' ccol="' + (ccol++) + '"' : '')
          trHtml += '<td' + (col < matrix.xAxisCodes.length ? ' class="row-data' + clearClass + '"' : newDataStyle) + clearAttr + '>'

          if (d != null) {
            var clearHtml = ''
            if (col == 0 && d.isNewData) {
              clearHtml = '<span class="btn-clear" title="清除该行计算" type="row"><i class="el-icon-delete"></i></span>'
            }
            if (col < matrix.xAxisCodes.length) {
              trHtml += (d.Explanation != null && d.Explanation != '') ? '<span class="icon-dataintro" title="' + d.Explanation + '"><i class="el-icon-info"></i></span>' : ''
              trHtml += '<span id="' + d.dimensionCode.toLowerCase() + '_' + d.id + '">' + d.name + clearHtml + '</span>'
            } else {
              var userdata = d.Id.indexOf('userdata:true') != -1;
              // if (d.FactValue!=NaN)
              // document.write(d.isNewData);
              // var vvv = parseFloat(d.FactValue).toFixed(matrix.displayPrecision);
              // console.log('printTableData ', d.FactValue)
              if (userdata) {
                // console.log('userdata d', d);
              }
              var vvv = d.FactValue
              if (vvv == undefined || vvv == null || vvv == 'NaN' || typeof vvv === 'object' || d.ComputeDel != undefined) // (vvv != '**' && isNaN(vvv))
                {vvv = '';}
              if (d.DisplayMinusSign != undefined)
                {vvv = '-';}
              var computeState = d.ComputeType == undefined ? '' : ' data-' + d.ComputeType
              var attrClass = userdata ? ' class="userdata-bgc' + computeState + '" ' : ''
              var attrDataNull = vvv == '' ? ' data-null="true" ' : ''
              if (vvv == '**') vvv = '[**]'
              trHtml += '<div id="' + d.Id + '" ' + attrClass + ' hasUser=' + (userdata ? 'true' : 'false') + attrDataNull + '>' + vvv + '</div>'
            }
            d = null
          } else {
            for (var kk = 0; kk < matrix.yAxisCodes.length; kk++) {
              tempId.push([matrix.yAxisCodes[kk], matrix.yAxisValues[col - matrix.xAxisCodes.length][kk]])
            }
            var id = bll.indexBLL.getFactValueRowId(tempId)
            //   alert(id);
            for (var kk = 0; kk < matrix.yAxisCodes.length; kk++) {
              tempId.pop()
            }
            id += '_userdata:true_'
            trHtml += '<div id="' + id + '" hasUser="true"></div>'
          }
          trHtml += '</td>'
        }
        for (var kk = 0; kk < matrix.xAxisCodes.length; kk++) {
          tempId.pop()
        }
        // tempId.splice(0);
        trHtml += '</tr>'

        html += trHtml
      }

      return '<tbody>' + html + '</tbody>'
    };

    // 格式化数据
    bll.factValueParseFloat = function (v) {
      return (isNaN(v) || v == null || v == '' || v == '-') ? v : parseFloat(parseFloat(v).toFixed(bll.displayPrecision))
    };
    // 按列计算（追加新行）
    bll.addNewRowData = function (matrix, titleArray, rowData, computeType) {
      // 新增纬度值和行索引
      var i, j
      var newRowArray = new Array()
      var idFieldArray = new Array()
      for (i = 0; i < matrix.xAxisCodes.length; i++) {
        var title = ''
        if (titleArray.length > i) title = titleArray[i]
        var code = matrix.xAxisCodes[i]
        var id = bll.addNew(code, title) //新增纬度
        newRowArray[i] = id
        idFieldArray.push([code.toLowerCase(), id])
      }
      matrix.addNewXAxis(newRowArray)
      bll.newXAxis.push(newRowArray)

      var idArray = idFieldArray.slice(0)
      for (i = 0; i < matrix.yAxisValues.length; i++) {
        var fact = FactValueInfo.createNew()
        var v = rowData[i]
        fact.FactValue = (isNaN(v) || v == null || v == '') ? null : parseFloat(parseFloat(v).toFixed(bll.displayPrecision))

        if (v == '-') fact.DisplayMinusSign = true
        //document.write("<BR/>f2=" +f2 + "<BR/>factValue=" + fact.FactValue);
        for (j = 0; j < matrix.yAxisValues[i].length; j++) {
          idArray.push([matrix.yAxisCodes[j].toLowerCase(), matrix.yAxisValues[i][j]])
        }
        // document.write("<BR/>idArray:" + idArray);
        var newid = bll.indexBLL.getFactValueRowId(idArray)
        fact.Id = newid + '_userdata:true_'
        fact.ComputeType = computeType
        fact.isNewData = true

        bll.initFactValue(bll.values.length, fact)

        //新增数据
        idArray = new Array()
        idArray = idFieldArray.slice(0)

      }
      bll.setMatrixDataRow(matrix, matrix.data.length)
      // document.write(newRow);

    };
    bll.newXAxis = new Array()
    bll.newYAxis = new Array()
    // 按行计算（追加新列）
    bll.addNewColData = function (matrix, titleArray, colData, computeType) {
      // 新增纬度值和行索引
      var i, j
      var newRowArray = new Array()
      var idFieldArray = new Array()
      for (i = 0; i < matrix.yAxisCodes.length; i++) {
        var title = ''
        if (titleArray.length > i) title = titleArray[i]
        var code = matrix.yAxisCodes[i]
        //alert(title);
        var id = bll.addNew(code, title) //新增纬度
        newRowArray[i] = id
        idFieldArray.push([code.toLowerCase(), id])
      }
      matrix.addNewYAxis(newRowArray)
      bll.newYAxis.push(newRowArray)

      var idArray = idFieldArray.slice(0)
      var newData = new Array()
      for (i = 0; i < matrix.xAxisValues.length; i++) {
        var fact = FactValueInfo.createNew()

        var v = colData[i]
        fact.FactValue = (isNaN(v) || v == null || v == '' || v == '-') ? null : parseFloat(parseFloat(v).toFixed(bll.displayPrecision))

        if (v == '-') fact.DisplayMinusSign = true

        for (j = 0; j < matrix.xAxisValues[i].length; j++) {
          idArray.push([matrix.xAxisCodes[j].toLowerCase(), matrix.xAxisValues[i][j]])
        }
        // document.write("<BR/>idArray:" + idArray);
        var newid = bll.indexBLL.getFactValueRowId(idArray)
        fact.Id = newid + '_userdata:true_'
        fact.ComputeType = computeType
        fact.isNewData = true

        newData[i] = fact
        bll.initFactValue(bll.values.length, fact)

        //新增数据
        idArray = new Array()
        idArray = idFieldArray.slice(0)
      }
      bll.appendHeader(matrix, newRowArray)
      bll.appendDataRow(matrix, newData)
    };

    // 新增计算数据
    bll.addComputeData = function (id, factvalue, computeType) {
      var newId = id.replace('userdata:false', 'userdata:true')
      var index = bll.indexBLL.getIndexById(newId)
      var value = (isNaN(factValue) || factValue == null || factValue == '' || factValue == '-') ? null : parseFloat(parseFloat(factvalue).toFixed(bll.displayPrecision))
      if (index > -1) {
        bll.values[index].FactValue = value
      } else {
        var factValue = FactValueInfo.createNew()
        factValue.Id = newId
        factValue.FactValue = value
        factValue.ComputeType = computeType
        factValue.isNewData = true
        if (factValue == '-')
          {factValue.DisplayMinusSign = true;}
        // 异常值删除|缺失值删除
        if (computeType == 'abnormal-del' || computeType == 'missing-del')
          {factValue.ComputeDel = true;}
        if (bll.indexBLL.getIndexById(id) > -1 && computeType != 'compute')
          {factValue.SourceFactValue = bll.values[bll.indexBLL.getIndexById(id)].FactValue;}

        bll.initFactValue(bll.values.length, factValue)
      }
    }
    // 获取数据序列信息
    bll.getDataSeriesInfo = function (matrix) {
      var codes = bll.indexBLL.getCodes()
      var others = new Array()
      var otherValues = new Array()
      for (var i = 0; i < codes.length; i++) {
        if (codes[i].toLowerCase() == bll.xAxisDimensionCode) continue
        if (codes[i].toLowerCase() == bll.defaultDimensionCode) continue
        others.push(codes[i])
        otherValues.push(bll.indexBLL.getCodeValues(codes[i]))
      }
      others.push(bll.defaultDimensionCode)
      otherValues.push(bll.indexBLL.getCodeValues(bll.defaultDimensionCode))

      var m = FactValueMatrix.createNew()
      var seriesData = m.setAxis(others + '', otherValues)
      var seriesText = new Array() //序列文本
      var seriesTextIndex = 0
      var seriesDimensionCount = matrix.xAxisCodes[0] == 'time_id' ? matrix.yAxisCodes.length : matrix.xAxisCodes.length
      for (var i = 0; i < seriesData.length; i++) {
        var _text = new Array();
          var _id = new Array();
          var dimensionInfo = null
        for (var j = 0; j < others.length; j++) {
          // if (text != '') text += ':', _id += ';';
          dimensionInfo = bll.dimensionBLL.getDimensionInfo(others[j], seriesData[i][j])
          if (dimensionInfo && !dimensionInfo.isNewData) {
            _text.push(dimensionInfo.name.replace(/ /g, ''))
            _id.push(dimensionInfo.dimensionCode + ':' + dimensionInfo.id)
          }
        }
        if (_text.length == seriesDimensionCount) {
          seriesText[seriesTextIndex] = {
            id: _id.join(';'),
            name: _text.join(':'),
            index: seriesTextIndex
          }
          seriesTextIndex++
        }
      }
      return seriesText
    };

    // 获取数据序列
    bll.getDataSeriesText = function (matrix) {
      var codes = bll.indexBLL.getCodes()
      var others = new Array()
      var otherValues = new Array()
      for (var i = 0; i < codes.length; i++) {
        if (codes[i].toLowerCase() == bll.xAxisDimensionCode) continue
        if (codes[i].toLowerCase() == bll.defaultDimensionCode) continue
        others.push(codes[i])
        otherValues.push(bll.indexBLL.getCodeValues(codes[i]))
      }
      others.push(bll.defaultDimensionCode)
      otherValues.push(bll.indexBLL.getCodeValues(bll.defaultDimensionCode))

      var m = FactValueMatrix.createNew()
      var seriesData = m.setAxis(others + '', otherValues)
      var seriesText = new Array() //序列文本
      for (var i = 0; i < seriesData.length; i++) {
        var text = new Array();
          var dimensionInfo = null
        for (var j = 0; j < others.length; j++) {
          dimensionInfo = bll.dimensionBLL.getDimensionInfo(others[j], seriesData[i][j])
          if (dimensionInfo && !dimensionInfo.isNewData)
            {text.push(dimensionInfo.name.replace(/ /g, ''));}
        }
        if (_text.length == matrix.yAxisCodes.length)
          {seriesText[i] = {
            name: text.join(':'),
            index: i
          };}
      }
      return seriesText
    };

    // 行计算
    bll.computeRows = function (matrix, fomula, titles) {
      fomula = fomula.replace(/R/g, '')
      fomula = fomula.replace(/C/g, '')
      //新增纬度值和行索引
      var i, j
      var titleArray = titles.split(',')
      var newRowArray = new Array()
      var idFieldArray = new Array()
      for (i = 0; i < matrix.xAxisCodes.length; i++) {
        var title = ''
        if (titleArray.length > i) title = titleArray[i]
        var code = matrix.xAxisCodes[i]
        var id = bll.addNew(code, title) //新增纬度
        newRowArray[i] = id

        idFieldArray.push([code.toLowerCase(), id])

      }
      matrix.addNewXAxis(newRowArray)


      //格式化表达式
      while (true) {
        var f = fomula.match(/{\d+}/)

        if (f == null) break
        f = f + '';
        var rowIndex = f.match(/\d+/)
        fomula = fomula.replace(f, 'matrix.getValueByNo(' + parseInt(rowIndex) + ',{columnIndex})')
      }

      // var newRow = new Array();

      var idArray = idFieldArray.slice(0)

      for (i = 0; i < matrix.yAxisValues.length; i++) {
        var f1 = fomula
        var f2 = f1.replace(/{columnIndex}/g, i + '')

        var fact = FactValueInfo.createNew()
        var v = eval(f2)
        if (v != null && v != NaN) {
          fact.FactValue = parseFloat(v).toFixed(matrix.displayPrecision)

        }
        fact.isNewData = true
        //document.write("<BR/>f2=" +f2 + "<BR/>factValue=" + fact.FactValue);

        for (j = 0; j < matrix.yAxisValues[i].length; j++) {
          idArray.push([matrix.yAxisCodes[j].toLowerCase(), matrix.yAxisValues[i][j]])

        }
        // document.write("<BR/>idArray:" + idArray);
        var newid = bll.indexBLL.getFactValueRowId(idArray)
        fact.Id = newid + '_userdata:false_'


        bll.initFactValue(bll.values.length, fact)

        //新增数据
        idArray = new Array()
        idArray = idFieldArray.slice(0)

      }
      bll.setMatrixDataRow(matrix, matrix.data.length)
      // document.write(newRow);

    };

    // 列计算
    bll.computeCols = function (matrix, fomula, titles) {
      // 新增纬度值和行索引
      fomula = fomula.replace(/R/g, '')
      fomula = fomula.replace(/C/g, '')

      var i, j
      var titleArray = titles.split(',')
      var newRowArray = new Array()
      var idFieldArray = new Array()
      for (i = 0; i < matrix.yAxisCodes.length; i++) {
        var title = ''
        if (titleArray.length > i) title = titleArray[i]
        var code = matrix.yAxisCodes[i]
        //alert(title);
        var id = bll.addNew(code, title) //新增纬度

        newRowArray[i] = id

        idFieldArray.push([code.toLowerCase(), id])

      }
      matrix.addNewYAxis(newRowArray)

      while (true) {
        var f = fomula.match(/{\d+}/)

        if (f == null) break
        f = f + '';
        var colIndex = f.match(/\d+/)
        fomula = fomula.replace(f, 'matrix.getValueByNo({rowIndex},' + (parseInt(colIndex) - 1) + ')')
      }

      var idArray = idFieldArray.slice(0)
      var newData = new Array()
      for (i = 0; i < matrix.xAxisValues.length; i++) {
        var f1 = fomula
        var f2 = f1.replace(/{rowIndex}/g, (i + 1) + '')
        //  document.write('<BR/>' + f2);
        var fact = FactValueInfo.createNew()
        fact.isNewData = true
        var v = eval(f2)
        if (v != null && v != NaN) {
          fact.FactValue = parseFloat(v).toFixed(matrix.displayPrecision)
        }

        for (j = 0; j < matrix.xAxisValues[i].length; j++) {
          idArray.push([matrix.xAxisCodes[j].toLowerCase(), matrix.xAxisValues[i][j]])

        }

        newData[i] = fact
        // document.write("<BR/>idArray:" + idArray);
        var newid = bll.indexBLL.getFactValueRowId(idArray)
        fact.Id = newid + '_userdata:false_'
        bll.initFactValue(bll.values.length, fact)

        //新增数据
        idArray = new Array()
        idArray = idFieldArray.slice(0)
      }
      bll.appendHeader(matrix, newRowArray)
      bll.appendDataRow(matrix, newData)

    };

    // 校验表达式 axis=row col
    bll.checkFomula = function (matrix, axis, fomula) {
      if (fomula == '') {
        return false
      }
      var min = 1
      var max = 1
      switch (axis.toLowerCase()) {
        case 'row': {
          fomula = fomula.replace(/C/g, '')
          max = matrix.xAxisValues.length
          break;
        }
        case 'col': {
          fomula = fomula.replace(/R/g, '')
          max = matrix.yAxisValues.length
          break;
        }
        default: {
          fomula = fomula.replace(/C/g, '')
          fomula = fomula.replace(/R/g, '')
          max = matrix.xAxisValues.length > matrix.yAxisValues.length ? matrix.xAxisValues.length : matrix.yAxisValues.length
          break;
        }
      }
      var msg = ''
      try {
        while (true) {
          var f = fomula.match(/{\d+}/)
          if (f == null) break
          f = f + '';
          var colIndex = f.match(/\d+/)

          if (colIndex < min) {
            msg = '表达式中序号错误'
            return false
          }
          if (colIndex > max) {
            msg = '表达式中序号错误'
            return false
          }
          fomula = fomula.replace(f, '100')
        }
      } catch (e) {
        alert('[checkFomula.1]=' + e)
      }
      try {
        var ctx = eval(fomula)
        //  document.writeln(ctx);
      } catch (e) {
        // alert('[checkFomula.2]=' + e);
        msg = '表达式错误'
        return false
      }
      return true
    };
    // 新增纬度
    bll.addNew = function (code, title) {
      // 新增纬度
      var id = bll.dimensionBLL.addNew(code, title)
      //新增纬度索引
      bll.indexBLL.initCodeValue(code, id)

      return id
      //alert(id);
    };

    // 获取纬度文本
    bll.getCodeValueText = function (code, id) {
      var d = bll.dimensionBLL.getDimensionInfo(code, id)
      if (d != null) return d.name
      return ''
    };

    // 获取行向量 做图
    bll.getRowVectorForGraph = function (matrix, row) {
      var offset = matrix.xAxisCodes.length
      var seriesCount = 1

      var temp1 = new Array()

      var a = matrix.yAxisCodes.length - 1
      for (j = 0; j < matrix.yAxisValues.length; j++) {
        if (temp1.length == 0) {
          temp1.push(matrix.yAxisValues[j][a])
          continue;
        }
        if (temp1.indexOf(matrix.yAxisValues[j][a]) > -1) continue
        temp1.push(matrix.yAxisValues[j][a])

      }
      seriesCount = temp1.length

      var series = new Array()
      var seriesIndex = 0
      var cc = 0
      for (j = 0; j < matrix.yAxisValues.length; j++) {
        if (j == 0 || cc == seriesCount) {
          cc = 0
          seriesIndex = series.length
          series[seriesIndex] = new Array()
          //series[seriesIndex][0] = 'series' + ((j + 1) / seriesCount);
          var seriesName = ''

          var l = matrix.yAxisCodes.length - 1
          // if (seriesCount == matrix.yAxisValues.length) l = matrix.yAxisCodes.length;

          for (i = 0; i < l; i++) {
            var code1 = matrix.yAxisCodes[i]
            var codeValue1 = matrix.yAxisValues[j][i]
            if (seriesName != '') seriesName += ':'
            seriesName += bll.getCodeValueText(code1, codeValue1)

          }
          if (seriesName == '') {
            for (k = 0; k < matrix.xAxisCodes.length; k++) {
              var code1 = matrix.xAxisCodes[k]
              var codeValue1 = matrix.xAxisValues[row][k]
              if (seriesName != '') seriesName += ':'
              seriesName += bll.getCodeValueText(code1, codeValue1)
            }
          }
          series[seriesIndex][0] = seriesName
          series[seriesIndex][1] = new Array() //text
          series[seriesIndex][2] = new Array() //value
          series[seriesIndex][3] = matrix.yAxisCodes[matrix.yAxisCodes.length - 1]

        }

        var code = matrix.yAxisCodes[matrix.yAxisCodes.length - 1]
        var codeValue = matrix.yAxisValues[j][matrix.yAxisCodes.length - 1]


        var t = bll.getCodeValueText(code, codeValue)

        var curseriesIndex = seriesIndex

        series[curseriesIndex][1].push(t)
        var textIndex = series[curseriesIndex][1].length - 1
        var f = matrix.getFactValue(row, j + offset)
        if (f != null)
          {series[curseriesIndex][2][textIndex] = f.FactValue;}
        cc = cc + 1
      }
      return series
    }

    // 获取列向量 做图
    bll.getColumnVectorForGraph = function (matrix, col) {
      var offset = matrix.xAxisCodes.length
      var seriesCount = 1

      var temp1 = new Array()

      var a = matrix.xAxisCodes.length - 1
      for (j = 0; j < matrix.xAxisValues.length; j++) {
        if (temp1.length == 0) {
          temp1.push(matrix.xAxisValues[j][a])
          continue;
        }
        if (temp1.indexOf(matrix.xAxisValues[j][a]) > -1) continue
        temp1.push(matrix.xAxisValues[j][a])

      }
      seriesCount = temp1.length
      //alert(seriesCount);

      var series = new Array()
      var seriesIndex = 0
      var cc = 0
      for (j = 0; j < matrix.xAxisValues.length; j++) {
        if (j == 0 || cc == seriesCount) {
          seriesIndex = series.length
          //alert('j=' + j + ' serieslength=' + seriesIndex + ' cc=' + cc + '   seriesCount=' + seriesCount);
          series[seriesIndex] = new Array()
          //series[seriesIndex][0] = 'series' + ((j + 1) / seriesCount);
          var seriesName = ''
          var l = matrix.xAxisCodes.length - 1

          for (i = 0; i < l; i++) {
            var code1 = matrix.xAxisCodes[i]
            var codeValue1 = matrix.xAxisValues[j][i]
            if (seriesName != '') seriesName += ':'
            seriesName += bll.getCodeValueText(code1, codeValue1)

          }
          if (seriesName == '') {
            for (k = 0; k < matrix.yAxisCodes.length; k++) {
              var code1 = matrix.yAxisCodes[k]
              var codeValue1 = matrix.yAxisValues[col][k]
              if (seriesName != '') seriesName += ':'
              seriesName += bll.getCodeValueText(code1, codeValue1)
            }
          }
          series[seriesIndex][0] = seriesName
          series[seriesIndex][1] = new Array() //text
          series[seriesIndex][2] = new Array() //value
          series[seriesIndex][3] = matrix.xAxisCodes[matrix.xAxisCodes.length - 1]
          cc = 0
        }

        var code = matrix.xAxisCodes[matrix.xAxisCodes.length - 1]
        var codeValue = matrix.xAxisValues[j][matrix.xAxisCodes.length - 1]


        var t = bll.getCodeValueText(code, codeValue)

        var curseriesIndex = seriesIndex

        series[curseriesIndex][1].push(t)
        var textIndex = series[curseriesIndex][1].length - 1
        var f = matrix.getFactValue(j, col + offset)
        if (f != null)
          {series[curseriesIndex][2][textIndex] = f.FactValue;}
        else
          {series[curseriesIndex][2][textIndex] = null;}
        cc = cc + 1
      }
      return series
    }

    // 获取数据 timeid regionArray：[1，2，4] otherArray:["indicator",1]  在WEB GIS中使用
    // 返回[region，value] [1,33.44]
    bll.getGisValues = function (timeid, gisData) {
      var dataArray = gisData.getDataByTimeId(timeid)
      var i
      for (i = 0; i < dataArray.length; i++) {
        var regionId = dataArray[i][0]
        var webgisindex = bll.regionGisMapping[regionId]
        dataArray[i][0] = webgisindex
      }

      return dataArray
    };
    // 查询数据，数组 1纬索引为时间，2纬索引是 地区  otherArray:[["indicator",1]]
    bll.QueryGisData = function (gisInfo, otherArray, isuser) {
      var dataMatrix = GisDataInfo.createNew()
      dataMatrix.timeArray = gisInfo.timeArray
      dataMatrix.regionArray = gisInfo.regionArray
      dataMatrix.otherValueArray = otherArray
      dataMatrix.data = new Array()
      for (var i = 0; i < dataMatrix.timeArray.length; i++) {
        dataMatrix.data[i] = new Array()
        for (var j = 0; j < dataMatrix.regionArray.length; j++) {
          var timeid = dataMatrix.timeArray[i]
          var regionid = dataMatrix.regionArray[j]
          if (bll.regionGisMapping.length <= parseInt(regionid) || bll.regionGisMapping[parseInt(regionid)] == undefined) {
            continue
          }
          var temp = new Array()
          temp.push(['time', timeid])
          /*暂时注销测试*/
          //temp.push(["region", regionid]);
          temp.push(['state', regionid])

          for (var k = 0; k < otherArray.length; k++)
            {temp.push([otherArray[k][0], otherArray[k][1]]);}
          var id = bll.indexBLL.getFactValueRowIndex(temp, isuser)
          var v = bll.values[id]
          //  document.write("<BR/>FactValue=" + v.FactValue)
          if (v != null && !isNaN(v.FactValue)) {
            // var v1 = v.FactValue.toFixed(bll.displayPrecision);
            var v1 = v.FactValue
            if (isNaN(dataMatrix.minValue)) dataMatrix.minValue = v1
            if (isNaN(dataMatrix.maxValue)) dataMatrix.maxValue = v1
            if (parseFloat(dataMatrix.minValue) > parseFloat(v1)) dataMatrix.minValue = parseFloat(v1)
            if (parseFloat(dataMatrix.maxValue) < parseFloat(v1)) dataMatrix.maxValue = parseFloat(v1)

            dataMatrix.data[i][j] = v1
          }
        }
      }
      return dataMatrix
    };

    bll.regionGisMapping = new Array() //webGIS地区对应表 索引为RegionId，值为GisIndex
    // [ddd,ddd,ddd]  // regions[]
    //[[22,3,4,5]]
    bll.getGisDataGroupByTimeId = function (timeid,
      regionArrray,
      indicatorArray,
      otherArray) {
      var idArray = new Array()
      var result = new Array()
      idArray.push(['time', timeid])
      for (var i = 0; i < regionArrray.length; i++) {
        idArray.push([bll.gisCode, regionArrray[i]])
        result[i] = new Array()
        for (var j = 0; j < indicatorArray.length; j++) {
          idArray.push(['indicator', indicatorArray[j]])
          if (otherArray != null && otherArray.length > 0) {
            for (var kk = 0; kk < otherArray.length; kk++) {
              idArray.push(otherArray[kk])
            }
          }
          var index = bll.indexBLL.getFactValueRowIndex(idArray, true)
          if (index != -1) {
            result[i][j] = bll.values[index].FactValue
          }

          if (otherArray != null && otherArray.length > 0) {
            for (var kk = 0; kk < otherArray.length; kk++) {
              idArray.pop()
            }
          }
          idArray.pop()
        }
        idArray.pop()
      }
      return result
    };
    bll.getGisIndex = function (regionid) {
      return bll.regionGisMapping[regionid]
    };

    bll.initGisMapping = function (databaseid) {
      if (bll.indexBLL.getCodeIndex(bll.gisCode) == -1) return
      if (bll.regionGisMapping != null && bll.regionGisMapping.length > 0) {
        return
      }

      $.ajax({
        url: '/DB/Query/GetGisMappingJson',
        dataType: 'json',
        type: 'get',
        async: false,
        contentType: 'application/json; charset=gb2312',
        data: {
          databaseId: databaseid
        },
        success: function (data) {
          bll.regionGisMapping = new Array()
          for (var i = 0; i < data.length; i++) {
            // document.write("<br/>" + data[i][0] + ':' + data[i][1]);
            bll.regionGisMapping[data[i][0]] = data[i][1]

          }
        }
      })
    };
    bll.setGisMapping = function (mappingArray) {
      bll.regionGisMapping = mappingArray
    };
    bll.getRegionIdByGisIndex = function (gisIndex) {
      return bll.regionGisMapping.indexOf(gisIndex)
    };

    // WebGis
    bll.createWebGis = function (databaseid) {
      // 校验是否存在地区纬度
      if (bll.indexBLL.getCodeIndex(bll.gisCode) == -1) return null

      bll.initGisMapping(databaseid)

      //获取时间纬度
      var timeArray = bll.indexBLL.getCodeValues('time')
      //地区纬度
      var regionArray = bll.indexBLL.getCodeValues(bll.gisCode)

      var otherCodeArray = new Array() //其它纬度Code
      var otherCodeValues = new Array() //其它纬度Code值
      var i

      //其它纬度
      for (i = 0; i < bll.indexBLL.codeArray.length; i++) {
        if (bll.indexBLL.codeArray[i].toLowerCase() == 'time' ||
          bll.indexBLL.codeArray[i].toLowerCase() == bll.gisCode.toLowerCase()
        ) {
          continue
        }
        otherCodeArray.push(bll.indexBLL.codeArray[i])
      }
      // 其它纬度值
      for (i = 0; i < otherCodeArray.length; i++) {
        otherCodeValues[i] = bll.indexBLL.getCodeValues(otherCodeArray[i])
      }

      var gis = GisSettingBLL.createNew()
      gis.timeArray = timeArray
      gis.regionArray = regionArray
      gis.otherCodeArray = otherCodeArray
      gis.otherValueArray = otherCodeValues
      gis.maxValue = bll.maxValue
      gis.minValue = bll.minValue

      return gis
    };

    // 图形X轴维度代码
    bll.xAxisDimensionCode = 'time_id'
    bll.defaultDimensionCode = 'indicator_id'
    bll.setXAxisDimensionCode = function (code) {
      bll.xAxisDimensionCode = code
    };
    // 创建图形数据对象
    bll.createChartInfo = function (matrix) {
      var timeCode = 'time_id'
      var timeArray = new Array()
      if (matrix.xAxisCodes[0] == timeCode) {
        matrix.data.forEach(d => {
          timeArray.push(d[0])
        })
      } else {
        for (var i = matrix.xAxisCodes.length; i < matrix.header[0].length; i++) {
          timeArray.push(matrix.header[0][i])
        }
      }
      // console.log(timeArray,'timeArray')

      var codes = bll.indexBLL.getCodes()
      // console.log(codes,'codes')
      var others = new Array()
      var otherValues = new Array()
      for (var i = 0; i < codes.length; i++) {
        if (codes[i].toLowerCase() == timeCode) continue
        if (codes[i].toLowerCase() == bll.defaultDimensionCode) continue
        others.push(codes[i])
        otherValues.push(bll.indexBLL.getCodeValues(codes[i]))
      }
      others.push(bll.defaultDimensionCode)
      otherValues.push(bll.indexBLL.getCodeValues(bll.defaultDimensionCode))

      var m = FactValueMatrix.createNew()
      var seriesData = m.setAxis(others + '', otherValues)
      var data = new Array() //数据
      var seriesText = new Array() //序列文本
      for (var i = 0; i < seriesData.length; i++) {
        data[i] = new Array()
        var idArray = new Array()
        var text = ''
        for (var j = 0; j < others.length; j++) {
          if (text != '')
            {text += ':';}
          text += bll.dimensionBLL.getDimensionInfo(others[j], seriesData[i][j]).name
          idArray.push([others[j], seriesData[i][j]])
        }
        seriesText[i] = text

        for (var k = 0; k < timeArray.length; k++) {
          idArray.push(['time_id', timeArray[k].id])
          var rowIndex = bll.indexBLL.getFactValueRowIndex(idArray, 'true')
          var factvalue = NaN
          if (rowIndex > -1) {
            var fact = bll.values[rowIndex]
            factvalue = fact.FactValue
            factvalue = parseFloat(parseFloat(factvalue).toFixed(bll.displayPrecision))
          }
          data[i][k] = factvalue
          idArray.pop()
        }
      }
      var chartInfo = ChartInfoParm.createNew()
      chartInfo.xAxis = timeArray.map(t => {
        return t.name
      })
      chartInfo.seriesText = seriesText
      chartInfo.seriesData = data
      return chartInfo
    };

    return bll
  }

}

var ChartInfoParm = {
  createNew: function () {
    var chartInfo = {}
    chartInfo.xAxis = new Array()
    chartInfo.seriesText = new Array()
    chartInfo.seriesData = new Array()

    return chartInfo
  }

}

/* ---------------------Math 对象方法----------------------*/
// 返回数的绝对值
function abs (x) {
  return Math.abs(x)
}
// 返回数的反余弦值
function acos (x) {
  return Math.acos(x)
}
// 返回数的反正弦值
function asin (x) {
  return Math.asin(x)
}
// 以介于 -PI/2 与 PI/2 弧度之间的数值来返回 x 的反正切值
function atan (x) {
  return Math.atan(x)
}
// 返回从 x 轴到点 (x,y) 的角度（介于 -PI/2 与 PI/2 弧度之间）
function atan2 (y, x) {
  return Math.atan2(y, x)
}
// 对数进行上舍入
function ceil (x) {
  return Math.ceil(x)
}
// 返回数的余弦
function cos (x) {
  return Math.cos(x)
}
// 返回 e 的指数
function exp (x) {
  return Math.exp(x)
}
// 对数进行下舍入
// function exp(x) {
//   return Math.floor(x);
// }
// 返回数的自然对数（底为e）
function log (x) {
  return Math.log(x)
}
// 返回 x 和 y 中的最高值
function max (x, y) {
  return Math.max(x, y)
}
// 返回 x 和 y 中的最低值
function min (x, y) {
  return Math.min(x, y)
}
// 返回 x 的 y 次幂
function pow (x, y) {
  return Math.pow(x, y)
}
// 返回数的正弦
function sin (x) {
  return Math.sin(x)
}
// 返回数的平方根
function sqrt (x) {
  return Math.sqrt(x)
}
// 返回角的正切
function tan (x) {
  return Math.tan(x)
}

export default FactValueBLL
